/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Pairing_Noun_MatchesInputs */



/**
* | output |
* | --- |
* | "matches" |
*
* @param {Tournaments_Lib_Pairing_Noun_MatchesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_pairing_noun_matches = /** @type {((inputs?: Tournaments_Lib_Pairing_Noun_MatchesInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Pairing_Noun_MatchesInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Matches")
	if (locale === "fr") return /** @type {LocalizedString} */ ("matchs")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("比赛")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("比賽")
	if (locale === "ko") return /** @type {LocalizedString} */ ("경기")
	return /** @type {LocalizedString} */ ("matches")
});